/* CR8 purchase panel behaviour.

   Everything here is progressive enhancement. The markup is already correct and
   submittable with JavaScript disabled: subscription is the default checked
   state and the selling_plan input ships enabled. This script only makes the
   panel react to the customer changing their mind.

   Three responsibilities:
     1. Purchase type  — enable/disable the selling_plan input, swap the bundle
                         totals between one-time and subscription pricing, show
                         or hide the "what's included" list, relabel the button.
     2. Bundle tiers   — mirror the chosen tier into the real quantity input.
     3. Selected state — keep .is-selected in sync for engines without :has().

   Deliberately no framework and no build step: this file is served straight
   from the theme assets and has to work on the oldest phone that reaches the
   storefront. */

(function () {
  'use strict';

  var SELECTED = 'is-selected';

  /* The .is-selected class is kept in sync on EVERY change (not only on
     browsers without :has()): the server renders the class on the default
     option, and :has() alone can't remove that stale class once the customer
     picks the other option. */
  function markSelected(container, itemSelector, selectedItem) {
    if (!container) return;
    var items = container.querySelectorAll(itemSelector);
    for (var i = 0; i < items.length; i++) {
      if (items[i] === selectedItem) {
        items[i].classList.add(SELECTED);
      } else {
        items[i].classList.remove(SELECTED);
      }
    }
  }

  /* --- Step 1: subscribe vs one-time ------------------------------------- */

  function initPurchaseTypes(panel) {
    var group = panel.querySelector('[data-cr8-purchase-types]');
    if (!group) return; // no selling plan on this product — one-time only

    var radios = group.querySelectorAll('[data-cr8-purchase-radio]');
    if (!radios.length) return;

    var sellingPlanInput = panel.querySelector('[data-cr8-selling-plan]');
    var included = panel.querySelector('[data-cr8-included]');
    var submit = panel.querySelector('[data-cr8-submit]');
    var tiers = panel.querySelectorAll('[data-cr8-bundle-tier]');

    function apply(mode) {
      var isSubscription = mode === 'subscription';

      /* A disabled input is not submitted at all. Blanking the value instead
         would post an empty selling_plan, which Shopify rejects. */
      if (sellingPlanInput) {
        sellingPlanInput.disabled = !isSubscription;
      }

      if (included) {
        included.hidden = !isSubscription;
      }

      if (submit && !submit.disabled) {
        var label = isSubscription
          ? submit.getAttribute('data-label-subscription')
          : submit.getAttribute('data-label-onetime');
        if (label) submit.textContent = label;
      }

      for (var i = 0; i < tiers.length; i++) {
        var total = tiers[i].querySelector('[data-cr8-bundle-total]');
        if (!total) continue;
        var next = isSubscription
          ? tiers[i].getAttribute('data-sub-total')
          : tiers[i].getAttribute('data-onetime-total');
        if (next) total.textContent = next;
      }
    }

    for (var i = 0; i < radios.length; i++) {
      radios[i].addEventListener('change', function () {
        if (!this.checked) return;
        apply(this.value);
        markSelected(group, '[data-cr8-purchase-choice]', this.closest('[data-cr8-purchase-choice]'));
      });
    }

    /* Re-apply on load so a browser-restored radio state (back button, bfcache)
       matches what the rest of the panel is showing. */
    var checked = group.querySelector('[data-cr8-purchase-radio]:checked');
    if (checked) {
      apply(checked.value);
      markSelected(group, '[data-cr8-purchase-choice]', checked.closest('[data-cr8-purchase-choice]'));
    }
  }

  /* --- Step 2: how many pouches ------------------------------------------ */

  function initBundleTiers(group) {
    var form = group.closest('form');
    var quantityInput = form ? form.querySelector('[data-cr8-quantity-input]') : null;
    if (!quantityInput) return;

    var radios = group.querySelectorAll('[data-cr8-bundle-radio]');

    function sync(radio) {
      quantityInput.value = radio.value;
      markSelected(group, '[data-cr8-bundle-tier]', radio.closest('[data-cr8-bundle-tier]'));
    }

    for (var i = 0; i < radios.length; i++) {
      radios[i].addEventListener('change', function () {
        if (this.checked) sync(this);
      });
    }

    var checked = group.querySelector('[data-cr8-bundle-radio]:checked');
    if (checked) sync(checked);
  }

  /* --- Wiring ------------------------------------------------------------- */

  function initAll(scope) {
    if (!scope || !scope.querySelectorAll) return;

    var panels = scope.querySelectorAll('[data-cr8-purchase-panel]');
    for (var i = 0; i < panels.length; i++) {
      if (panels[i].dataset.cr8Initialised === 'true') continue;
      panels[i].dataset.cr8Initialised = 'true';
      initPurchaseTypes(panels[i]);
    }

    var tierGroups = scope.querySelectorAll('[data-cr8-bundle-tiers]');
    for (var j = 0; j < tierGroups.length; j++) {
      if (tierGroups[j].dataset.cr8Initialised === 'true') continue;
      tierGroups[j].dataset.cr8Initialised = 'true';
      initBundleTiers(tierGroups[j]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  /* Theme editor re-renders a section's DOM in place — re-scan just that node. */
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
